export type Industry = {
  slug: string
  name: string
  tagline: string
  challenge: string
  howTechHelps: string
  capabilities: string[]
}

export const industries: Industry[] = [
  {
    slug: 'business-and-professional-services',
    name: 'Business & Professional Services',
    tagline: 'Digital systems that simplify operations and strengthen customer relationships.',
    challenge:
      'Service businesses often run on a mix of spreadsheets, email, and manual coordination — which works until the business grows past it.',
    howTechHelps:
      'Clear digital systems for managing clients, projects, and information reduce friction and let teams focus on the work that matters.',
    capabilities: ['Client and project management systems', 'Websites and digital presence', 'Workflow automation'],
  },
  {
    slug: 'automotive',
    name: 'Automotive',
    tagline: 'Technology for vehicle businesses, mobility, automotive commerce, and customer experiences.',
    challenge:
      'Automotive businesses need to present inventory, pricing, and services clearly while managing operations behind the scenes.',
    howTechHelps:
      'Digital platforms that connect customer-facing commerce with the operational systems that support it.',
    capabilities: ['Inventory and listings platforms', 'Digital commerce', 'Customer experience design'],
  },
  {
    slug: 'real-estate',
    name: 'Real Estate',
    tagline: 'Digital products for property discovery, management, transactions, and information.',
    challenge:
      'Property information is often scattered, outdated, or hard to navigate — for buyers, renters, and the teams managing listings.',
    howTechHelps:
      'Structured, well-designed platforms make property discovery and management significantly easier for everyone involved.',
    capabilities: ['Property listing platforms', 'Management dashboards', 'Digital transaction tools'],
  },
  {
    slug: 'hospitality',
    name: 'Hospitality',
    tagline: 'Technology that improves operations, customer experience, and digital presence.',
    challenge:
      'Hospitality businesses compete on experience — but many still rely on outdated websites and disconnected booking or operations tools.',
    howTechHelps:
      'A strong digital presence paired with better operational systems improves both guest experience and day-to-day efficiency.',
    capabilities: ['Websites and digital presence', 'Booking and operations tools', 'Customer experience design'],
  },
  {
    slug: 'commerce-and-retail',
    name: 'Commerce & Retail',
    tagline: 'Digital products that help businesses reach customers and sell more effectively.',
    challenge:
      'Many businesses still lack a real digital storefront, making it harder to reach customers beyond word of mouth or foot traffic.',
    howTechHelps:
      'A well-built commerce platform gives businesses a direct, reliable way to reach and sell to customers online.',
    capabilities: ['Digital storefronts', 'Commerce platforms', 'Customer and inventory systems'],
  },
  {
    slug: 'institutions',
    name: 'Institutions',
    tagline: 'Digital systems that simplify complex processes and connect information.',
    challenge:
      'Institutions often manage complex processes and large amounts of information across teams and departments.',
    howTechHelps:
      'Purpose-built digital systems simplify complex processes and make information easier to access and act on.',
    capabilities: ['Information systems', 'Workflow platforms', 'Internal digital tools'],
  },
]

export function getIndustryBySlug(slug: string) {
  return industries.find((industry) => industry.slug === slug)
}
